import { useEffect } from 'react';
import { useFilters } from 'portal-commons';
import { useDispatch, useSelector } from 'react-redux';
import { enumController, profileController, UsecaseType } from '@/apis/core';
import { getRcsUseCases } from '@/shared_elements/actions/enumActionCreators';
import { FILTER_CONFIG, FILTER_LOADERS } from './constants';

const useRcsCampaignFilter = (): ReturnType<typeof useFilters> => {
  const filter = useFilters({
    configs: FILTER_CONFIG,
    loaders: FILTER_LOADERS,
  });

  const dispatch = useDispatch();
  const rcsUseCasesData = useSelector(
    (state: any) => state.shareReducer.enums.rcsUseCases
  );

  useEffect(() => {
    dispatch(getRcsUseCases());
  }, [dispatch]);

  useEffect(() => {
    filter.setOptions(
      'usecase',
      rcsUseCasesData.map((item: UsecaseType) => ({
        label: item.id,
        value: item.id,
      }))
    );
  }, [rcsUseCasesData]);

  const fetchOtherOptions = async () => {
    const { setOptions } = filter;
    const [dcaResult, billingResult] = await Promise.allSettled([
      profileController.getApprovedDcas(),
      enumController.getBillingCategories(),
    ]);

    if (dcaResult.status === 'fulfilled') {
      const approvedDcas = dcaResult.value;
      setOptions(
        'dcaUid',
        approvedDcas.map((item) => ({
          label: item.displayName,
          value: item.uid,
        }))
      );
    }

    if (billingResult.status === 'fulfilled') {
      const billingCategories = billingResult.value;
      setOptions(
        'billingCategory',
        billingCategories.map((item) => ({
          label: item,
          value: item,
        }))
      );
    }
  };

  useEffect(() => {
    fetchOtherOptions();
  }, []);

  return filter;
};

export default useRcsCampaignFilter;
